import React from 'react';

// Spec §6.2 step 2 — pick agent prompt, tool_hint, and (for extract_data) a schema.
const StepQuery = ({ formData, onSetFormData }) => {
  const handlePromptChange = (e) => onSetFormData({ ...formData, agentPrompt: e.target.value });
  const handleToolHintChange = (e) => {
    const next = e.target.value;
    // If user moves off query_structured_data, drop hourly back to daily.
    const patch = { ...formData, toolHint: next };
    if (next !== 'query_structured_data' && formData.schedule?.frequency === 'hourly') {
      patch.schedule = { ...formData.schedule, frequency: 'daily' };
    }
    onSetFormData(patch);
  };
  const handleSchemaChange = (e) => onSetFormData({ ...formData, schema: e.target.value });

  return (
    <div className="push-step-content">
      <h3 className="push-step-title">Step 2 — Agent query</h3>
      <p className="push-step-help">Tell the agent what to fetch each run. The schema is only required when extracting structured rows from documents.</p>

      <label className="push-label">Agent prompt</label>
      <textarea
        className="resui-textarea"
        rows={5}
        value={formData.agentPrompt}
        onChange={handlePromptChange}
        placeholder="e.g. Pull patient encounter rows for the last 24h."
        data-testid="push-agent-prompt"
      />

      <label className="push-label">Tool hint</label>
      <div className="push-radio-group" data-testid="push-tool-hint">
        <label className="resui-radio">
          <input
            type="radio"
            className="resui-radio-input"
            name="toolHint"
            value="extract_data"
            checked={formData.toolHint === 'extract_data'}
            onChange={handleToolHintChange}
          />
          <span className="resui-radio-mark" />
          <span className="resui-radio-label">extract_data — rows from documents</span>
        </label>
        <label className="resui-radio">
          <input
            type="radio"
            className="resui-radio-input"
            name="toolHint"
            value="query_structured_data"
            checked={formData.toolHint === 'query_structured_data'}
            onChange={handleToolHintChange}
          />
          <span className="resui-radio-mark" />
          <span className="resui-radio-label">query_structured_data — NL-to-SQL over tabular data</span>
        </label>
      </div>

      {formData.toolHint === 'extract_data' && (
        <>
          <label className="push-label">Schema (JSON, required for extract_data)</label>
          <textarea
            className="resui-textarea push-textarea-mono"
            rows={6}
            value={formData.schema}
            onChange={handleSchemaChange}
            placeholder='{"fields": [{"name": "patient_id", "type": "string"}]}'
            data-testid="push-schema"
          />
        </>
      )}
    </div>
  );
};

export default StepQuery;
